import styled from "@emotion/styled";
import { Container } from "@mui/material";
import React from "react";
const Contract = styled.div`
  z-index: 99999;
  /* margin-top: 110px; */
`;
const index = () => {
  return (
    <div>
      <Container maxWidth="xl">
        <Contract>Contract Address: TBA</Contract>
      </Container>
    </div>
  );
};

export default index;
